export const GET_ACTIVITIES_REQUEST = 'GET_ACTIVITIES_REQUEST';
export const GET_OBJECT_ACTIVITY_REQUEST = 'GET_OBJECT_ACTIVITY_REQUEST';
export const GET_USER_ACTIVITY_REQUEST = 'GET_USER_ACTIVITY_REQUEST';
export const GET_ACCOUNT_ACTIVITY_REQUEST = 'GET_ACCOUNT_ACTIVITY_REQUEST';
export const GET_CLIENT_ACTIVITY_REQUEST = 'GET_CLIENT_ACTIVITY_REQUEST';

export const getActivities = (callback) => ({
    type: GET_ACTIVITIES_REQUEST,
    payload: { callback }
});

function resolveActivityQueryOpts(opts) {
    if (typeof opts === 'function') {
        return { callback: opts, page: 1, limit: 25 };
    }
    const { callback, page = 1, limit = 25 } = opts || {};
    return { callback, page, limit };
}

export const getObjectActivity = (parentType, parentId, opts) => {
    const { callback, page, limit } = resolveActivityQueryOpts(opts);
    return {
        type: GET_OBJECT_ACTIVITY_REQUEST,
        payload: { parentType, parentId, callback, page, limit }
    };
};

export const getUserActivity = (userId, opts) => {
    const { callback, page, limit } = resolveActivityQueryOpts(opts);
    return {
        type: GET_USER_ACTIVITY_REQUEST,
        payload: { userId, callback, page, limit }
    };
};

export const getAccountActivity = (accountId, opts) => {
    const { callback, page, limit } = resolveActivityQueryOpts(opts);
    return {
        type: GET_ACCOUNT_ACTIVITY_REQUEST,
        payload: { accountId, callback, page, limit }
    };
};

export const getClientActivity = (clientId, opts) => {
    const { callback, page, limit } = resolveActivityQueryOpts(opts);
    return {
        type: GET_CLIENT_ACTIVITY_REQUEST,
        payload: { clientId, callback, page, limit }
    };
};
